<template>
  <div>
    <div class="header__page">
      <h1>Филиалы</h1>

      <div class="buttons">
        <Button
            v-show="!hasVisibleActionForDeleted"
            text="Создать"
            icon="addFile"
            width="100%"
            iconWidth="15px"
            class="buttons__item"
            @click="createFiliation()"
        />
        <Button
            v-show="hasVisibleAction && !hasVisibleActionForDeleted"
            text="Редактировать"
            icon="edit"
            width="100%"
            iconWidth="15px"
            class="buttons__item"
            @click="editFiliation()"
        />
        <Button
            v-show="hasVisibleAction  && !hasVisibleActionForDeleted"
            text="Удалить"
            icon="delete"
            width="100%"
            iconWidth="15px"
            class="buttons__item"
            @click="deleteFiliation()"
        />
        <Button
            v-show="hasVisibleActionForDeleted && !hasVisibleRecover"
            text="Восстановить"
            icon="user_restore"
            width="100%"
            iconWidth="15px"
            class="buttons__item"
            @click="restoreFiliation()"
        />
      </div>
    </div>
    <VSwitch v-model="isTrashed" label="Показать удалённые" @valueChange="getTrashedItems" />

    <div class="filiations">
      <Preloader v-if="treeFiliationsLoading" />

      <Subdivision
        v-show="!treeFiliationsLoading"
        v-for="(dep, i) in tree"
        :key="i"
        :node="dep"
        :isActiveId="isActiveId"
        routeName="SaveFiliationUpdate"
        @highlightField="highlightField"
        @outsideHandler="outsideHandler"
      />
    </div>
  </div>
</template>


<script>
import Button from "@/components/Button";
import Subdivision from "@/components/Subdivision.vue";
import Preloader from "@/components/Preloader.vue";
import { mapState, mapActions , mapGetters} from "vuex";
import {deleteFiliation, restoreFiliation} from "@/api/filiations";
import VSwitch from "@/components/VSwitch.vue";

function searchNode (tree, value, key = 'id') {
  while (tree.length) {
    const node = tree.shift()
    if (node[key] === value) {
      return node
    }
    node.children && tree.push(...node.children)
  }
  return null
}

export default {
  name: "Filiadtions",
  components: {
    VSwitch,
    Subdivision,
    Preloader,
    Button
  },
  mounted() {
    !this.tree.length && this.getTreeFiliations({ trashed: this.isTrashed });
  },
  data() {
    return {
      currentField: null,
      isActiveId: null,
      isTrashed: false
    };
  },
  computed: {
    ...mapState("filiations", ["treeFiliationsLoading"]),
    ...mapGetters({
      tree: "filiations/treeFiliations"
    }),

    hasVisibleAction () {
      return !!this.currentField?.id
    },
    hasVisibleActionForDeleted () {
      return !!this.currentField?.deleted_at
    },
    hasVisibleRecover () {
      const node = searchNode([...this.tree], this.currentField?.parent_id)
      return !!node?.deleted_at
    }
  },
  methods: {
    ...mapActions("filiations", ["getTreeFiliations", "setActiveEl"]),

    outsideHandler () {
      this.currentField = null
      this.highlightField(null)
    },

    highlightField (node) {
      this.isActiveId = node?.id
      this.currentField = { ...node }
    },

    createFiliation () {
      if (this.currentField?.id) {
        this.$router.push({ name: 'SaveFiliationCreate', params: { node: this.currentField } })
      } else {
        this.$router.push({ name: 'SaveFiliationCreate' })
      }
    },

    editFiliation () {
      const node = this.currentField
      this.$router.push({ name: 'SaveFiliationUpdate', params: { node, id_filiation: node.id } })
    },

    deleteFiliation() {
      const deleteFilFunc = () =>
          deleteFiliation(this.currentField?.id)
              .then(() => {
                this.getTreeFiliations({ trashed: this.isTrashed });
              })
              .finally(() => {
                this.outsideHandler()
              });

      this.$root.confrim(
          "Вы точно хотите удалить этот филиал?",
          deleteFilFunc,
          "Да"
      );
    },

    restoreFiliation() {
      const restoreFilFunc = () =>
          restoreFiliation(this.currentField?.id)
              .then(() => {
                this.getTreeFiliations({ trashed: this.isTrashed });
              })
              .finally(() => {
                this.outsideHandler()
              });

      this.$root.confrim(
          "Вы точно хотите восстановить этот филиал?",
          restoreFilFunc,
          "Да"
      );
    },

    getTrashedItems () {
      this.getTreeFiliations({ trashed: this.isTrashed });
    }
  },
};
</script>

<style lang="scss" scoped>
.filiations {
  background: #f1f6f9;
  margin-top: 24px;
  border-radius: 4px;
  padding: 36px 34px;
  overflow: auto;
  width: 100%;
  height: auto;
  min-height: calc(100vh - 365px);

  @media screen and (max-width:1500px) {
    padding: 32px;
  }
}
</style>
